module.exports = __webpack_public_path__ + "static/Louise-Ashley-66d1e95b4ac2cd2d20fd0ae72ad7e6cc.jpg";